<template>
  <div>
    <div v-for="addon in addons" :key="addon.id" class="lf-modal-wrapper__content-item">
      <div class="lf-modal-wrapper__content-item-block" @click="chooseItem(addon)">
        <div class="lf-modal-wrapper__content-item-block-icon">
          <div class="lf-modal-wrapper__content-item-block-icon-inner">
            <i :class="addon.icon.indexOf('icon-') !== -1 ? addon.icon : 'fa fa-' + addon.icon"></i>
            <span class="lf-modal-wrapper__content-item-block-icon-text">{{ addon.label }}</span>
          </div>
        </div>
        <div class="lf-modal-wrapper__content-item-block-text">
          <button type="button" class="btn btn-light">
            <i class="icon-plus"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { stringToSlug } from '@/utilities/Utilities';
import { APICategory, Addon } from '@/components/components/editing/Modals/interfaces';

export default defineComponent({
  name: 'ModalAddons',
  props: {
    addons: {
      type: Array as PropType<Addon[]>,
      required: true
    },
    categories: {
      type: Array as PropType<APICategory[]>,
      required: true
    }
  },
  emits: ['addItem'],
  setup(props, context) {
    const chooseItem = (addon: Addon) => {
      context.emit('addItem', addon.id);
    };

    return {
      stringToSlug,
      chooseItem
    };
  }
});
</script>
